import ItnAPI from './_integrationApi.js';
import httpClient from '@/apis/base/httpclient';

class IntegrationACTApi extends ItnAPI {
  constructor() {
    super();
  }
  controllerName = 'ACTs';

  /**
   * Lấy hóa đơn tài chính
   * nnlinh 13.10.2023
   */
   GetDebtInvoiceACT() {
    let request = {
      url: this.getAPIUrl() + '/DebtInvoiceACT',
    };
    return this.getAsync(request);
  }

    /**
   * Lấy dữ liệu sinh từ hóa đơn tài chính
   * nnlinh 13.10.2023
   */
     GetDataDebtInvoiceGenerate(data) {
      let request = {
        url: this.getAPIUrl() + '/DataDebtInvoiceGenerate',
        data: data
      };
      return this.postAsync(request);
    }

  /**
   * Lấy danh sách hóa đơn chưa thanh toán từ ACT
   * ndthien 17/11/2023
   */
  GetDebtNotPaymentInvoiceToACT(){
    let request = {
      url: this.getAPIUrl() + '/DebtInvoiceNotPaymentACT',
    };
    return this.getAsync(request);
  }

  /**
   * Lấy dnah sách hóa đơn từ ACT quá hạn
   * ndthien 17/11/2023
   */
  GetDebtInvoiceOutOfDate(){
    let request = {
      url: this.getAPIUrl() + '/DebtInvoiceOutOfDate',
    };
    return this.getAsync(request);
  }
  /**
   * Lưu liên kết giữa hóa đơn với giấy rút dự toán
   *  DTQUOC 22.11.2023
   */
  InsertBuPlanWithdrawReferenceInvoiceAct(data) {
    let request = {
      url: this.getAPIUrl(),
      data: data
    };
    return this.postAsync(request);
  }
}
export default new IntegrationACTApi();
